import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import RelatedOrdersFieldsList from "./RelatedOrdersFieldsList";
import { WarehouseProvider } from "src/providers/WarehousesStore";
import PreloaderLine from "src/components/Preloader/PreloaderLine";
import { useWDetailsContext } from "src/providers/WarehouseDetailsStore";
import { ServicesProvider } from "src/providers/ServicesStore";
import Pagination from "./Pagination";
import ServiceTable from "./ServiceTable";
import CommonList from "src/components/CommonList";
import { useServicesContext } from "src/providers/ServicesStore";
import { ServiceOrder } from "src/types";
import PageActions from "./components/PageActions";
import TabsContainer from "src/components/TabsContainer";
import { useTranslation } from "react-i18next";

export const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.palette.functionalColors.dark,
    padding: theme.spacing(2),
  },
  detailsRoot: {
    paddingBottom: 0,
    marginLeft: theme.spacing(4),
  },
  activeServiceOrder: {
    backgound: "#fff",
  },
  panelSummary: {
    display: "flex",
    flexDirection: "row-reverse",
    padding: "0 4px",
    "& :focused": {
      backgroundColor: "#fff",
    },
    "& >div": {
      margin: 0,
    },
    "& >.Mui-expanded": {
      margin: 0,
    },

    "& .MuiListItem-gutters": {
      padding: 4,
    },
    "& .MuiIconButton-root": {
      padding: theme.spacing(1),
    },
  },
  accordionDetails: {
    flexDirection: "column",
  },
}));
const RelatedOrders = () => {
  const { t } = useTranslation(`warehouses`);
  const {
    relatedOrders: { serviceOrders, loading },
  } = useWDetailsContext();
  const { callServicesAPI } = useServicesContext();

  const handlerServices = useCallback(
    () => ({ id }: ServiceOrder) => {
      callServicesAPI.fetchingServices(id!);
    },
    []
  );

  return (
    <TabsContainer title={t("labels.related_orders")}>
      <PageActions />
      <PreloaderLine loading={loading} />
      <CommonList<ServiceOrder>
        listEntities={serviceOrders}
        handlerOnOpen={handlerServices}
        entityFields={(ent) => <RelatedOrdersFieldsList data={ent} />}
        entityDetails={(ent) => <ServiceTable data={ent} />}
      />
      <Pagination />
    </TabsContainer>
  );
};

const RelatedOrdersPage = () => (
  <WarehouseProvider>
    <ServicesProvider>
      <RelatedOrders />
    </ServicesProvider>
  </WarehouseProvider>
);

export default RelatedOrdersPage;
